export { default as ShortcutsDialog } from './ShortcutsDialog.vue';
